/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js"


const PeopleNoRecords = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.noRecordsWrapper}>
      <p> <FormattedMessage id="peopleNoRecords.title"/> </p>
    </div>
  )
}

export default PeopleNoRecords;
